import { MastraClient } from '@mastra/client-js';

export const createMastraClient = ({
    token,
    selectedModel,
}: {
    token: string;
    selectedModel?: string;
}): MastraClient => {
    return new MastraClient({
        baseUrl: import.meta.env.VITE_MASTRA_BASE_URL || 'http://localhost:4111',
        headers: {
            'x-mastra-dev-playground': 'false',
            // 'x-mastra-selected-model': selectedModel,
            Authorization: `Bearer ${token}`,
        },
    });
};
